import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.869 5.333c-2.65 0-5.396.106-8.24.316a4.278 4.278 0 0 0-3.962 4.266v9.474a4.278 4.278 0 0 0 4.277 4.278h15.704a4.278 4.278 0 0 0 4.263-3.924c.133-1.606.2-3.354.2-5.243 0-1.847-.064-3.495-.191-4.947a4.278 4.278 0 0 0-3.915-3.889 100.26 100.26 0 0 0-8.136-.33ZM24 26.723a.611.611 0 0 0-.611-.612H8.722a5.5 5.5 0 0 1-5.5-5.5v-8.556a.611.611 0 0 0-1.222 0v8.556a6.722 6.722 0 0 0 6.722 6.722H23.39a.611.611 0 0 0 .611-.61Z",
    fill: "currentColor"
  }));
};

var SvgShareScreen = styled(SvgComponent).withConfig({
  displayName: "ShareScreen__SvgShareScreen",
  componentId: "sc-1vn8e6c-0"
})(["", " ", ""], size, color);
export default SvgShareScreen;